export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    "Per aspiranti sommelier, appassionati che vogliono studiare il vino in modo serio e professionisti della ristorazione, dell'hotellerie e dell'enoturismo.",
  ],
  ['In che formato ricevo il materiale?', 'In formato digitale (PDF), da leggere su telefono, tablet o computer.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento ricevi via email l’accesso a tutti i volumi e i bonus.'],
  [
    'Serve una preparazione specifica?',
    'No. Si parte dalle basi e si arriva a un livello professionale, passo dopo passo.',
  ],
  [
    'È un corso con certificazione?',
    'No, è una collezione di studio e consultazione: non rilascia certificati né diplomi ufficiali.',
  ],
  ['C’è una garanzia?', 'Sì, hai 7 giorni di garanzia di soddisfazione.'],
];
